import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import api from "../services/api";

export const FAVORITE_QUERIES_KEY = ["favorite queries"];

export type FavoriteQuery = {
  id: number;
  name: string;
  content: string;
};

export const useFavoriteQueries = () => {
  const queryClient = useQueryClient();

  const { data } = useQuery<AxiosResponse<Array<FavoriteQuery>>>({
    queryKey: FAVORITE_QUERIES_KEY,
    queryFn: api.listFavourites
  });

  const { mutate: remove, mutateAsync: removeAsync } = useMutation({
    mutationFn: (id: number) => api.deleteFavourite(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: FAVORITE_QUERIES_KEY });
    }
  });

  return { data, remove, removeAsync };
};
